export default "__VITE_ASSET__0OUn23FU__"